export default __webpack_public_path__ + "static/media/doodle.ab50da36.png";